module.exports = __webpack_public_path__ + "img/img31.bd0e159f.svg";